
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 8.5a3 3 0 100-6 3 3 0 000 6z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.153 6a.967.967 0 001.694 0M3.5 23.5l-2.014-2.517A4.5 4.5 0 01.5 18.171V13a1.5 1.5 0 012.56-1.06A1.5 1.5 0 013.5 13v3.875","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8 23.5v-3.136a4.493 4.493 0 00-.757-2.5L6.1 16.154a1.4 1.4 0 00-2.553.36 1.4 1.4 0 00.101.986L5 19.75m15.5 3.75l2.014-2.517a4.5 4.5 0 00.986-2.812V13a1.5 1.5 0 10-3 0v3.875","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16 23.5v-3.136a4.494 4.494 0 01.757-2.5l1.143-1.71a1.4 1.4 0 012.554.36 1.4 1.4 0 01-.101.986L19 19.75M12 .5a5 5 0 00-4.833 6.284A24.89 24.89 0 018 13a4 4 0 004 4 4 4 0 002.828-1.172A4 4 0 0016 13a24.894 24.894 0 01.833-6.216A5 5 0 0012 .5v0zM8.109 13.932l8.287-5.18m-8.887-.496l4.685 3.123","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    